<template>
    <LottieAnimation
        ref="anim"
        :animation-data="animationData"
        :auto-play="autoPlay"
        :loop="loop"
        :speed="speed"
        @loopComplete="$emit('loopComplete', $event)"
        @complete="$emit('complete', $event)"
        @enterFrame="$emit('enterFrame', $event)"
        @segmentStart="$emit('segmentStart', $event)"
        @stopped="$emit('stopped', $event)"
    />
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
import { ref } from "@vue/composition-api";

export default {
    name: "Animation",
    components: {
        LottieAnimation
    },
    props: {
        autoPlay: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: false
        },
        animationData: {
            type: Object,
            required: true
        },
        speed: {
            type: Number,
            default: 1
        }
    },
    setup(props, ctx) {
        const anim = ref(null)
        return {
            anim
        };
    }
};
</script>
